module.exports = __webpack_public_path__ + "static/img/kjdy11.bca3b9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/kjdy11.png
// module id = 326
// module chunks = 0